import { Button } from '@/shared/components/ui/button';
import { Skeleton } from '@/shared/components/ui/skeleton';
import { cn } from '@/shared/lib/utils';
import type { ReactNode } from 'react';

/** 빈 상태 — 기획서 문구를 그대로 넘긴다 */
export const EmptyState = ({
  message,
  action,
  className,
}: {
  message: ReactNode;
  action?: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-3 py-10 text-center text-[13px] text-ink-7',
      className,
    )}
  >
    <p>{message}</p>
    {action}
  </div>
);

/** 조회 실패 — X8 문구 + 다시 시도 */
export const ErrorState = ({
  onRetry,
  className,
}: {
  onRetry?: () => void;
  className?: string;
}) => (
  <EmptyState
    className={className}
    message="연결이 불안정해요. 잠시 후 다시 시도해주세요."
    action={
      onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          다시 시도
        </Button>
      )
    }
  />
);

export const LoadingBlock = ({ className }: { className?: string }) => (
  <Skeleton className={cn('h-32 w-full rounded-card', className)} />
);
